import React, { lazy, Suspense } from 'react';
import { CAMPAIGN_NODES } from "../content/campaign";
import { PLAYER } from "../data";

function Game({ app, gameType, levelId, onLeaveGame }) {
  // Dynamically construct the import path from the gameType
  const GameComponent = lazy(() =>
    import(`../${gameType}/Game`).catch((error) => {
      console.error(`Failed to load game type: ${gameType}`, error);
      return {
        default: () => <div>Failed to load game type: {gameType}</div>
      };
    })
  );

  console.log('onLeaveGame', onLeaveGame);

  function handleFinishGame(isVictory, progressPercentage) {
    onLeaveGame({isVictory, progressPercentage});
  }

  // Error boundary for the entire game component
  const handleError = (error) => {
    console.error('Game component error:', error);
    return <div>Something went wrong loading the game. Please try again.</div>;
  };

  return (
    <Suspense
      fallback={<div>Loading game...</div>}
      onError={handleError}
    >
      <GameComponent
        app={app}
        levelId={levelId}
        onFinishGame={handleFinishGame}
      />
    </Suspense>
  );
}

export default Game;